import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../../../../Components/Panel/Panel";
import { InputGroup, Input, InputGroupAddon, Button, Alert } from "reactstrap";

import Pagination from "../../../../../../Components/Pagination/QSP";
import ReactMoment from "react-moment";
import NumberFormat from "react-number-format";
import Category from "./ListCategory";
import { commonStatusName } from "../../../../../../Components/User/UserNames";

const List = ({
  history,
  match,
  location,
  config,
  page,
  keyword,
  keywordInput,
  blockSize,
  first,
  data,
  loading,
  baseUrl,
  handleSearch,
}) => {
  return (
    <>
      <Helmet>
        <title>쿠폰 관리 | 한밭페이</title>
      </Helmet>
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/dashboard">Home</Link>
          </li>
          <li className="breadcrumb-item active">쿠폰</li>
        </ol>
        <h1 className="page-header">쿠폰</h1>
        <div className="row">
          <div className="col-xs-12">
            <Panel>
              <PanelHeader noButton={true}>
                목록({!loading && data.AdminCouponList.count}건)
              </PanelHeader>
              <Alert className="bg-gray-transparent-1">
                <Category
                  history={history}
                  match={match}
                  location={location}
                  config={config}
                />
                <div className="row m-t-15">
                  <div className="col-xs-12">
                    <form onSubmit={handleSearch}>
                      <InputGroup>
                        <Input
                          type="text"
                          className="input-white"
                          placeholder="검색어(이름) 입력"
                          value={keywordInput.value}
                          onChange={keywordInput.onChange}
                        />
                        <InputGroupAddon addonType="append">
                          <Button size="sm" color="white">
                            <i className="fa fa-search fa-fw"></i>
                          </Button>
                          <Link
                            to={`/couponConfigs/${config.AdminCouponConfig.id}/edit${location.search}`}
                            className="btn btn-white"
                          >
                            <i className="fa fa-cog fa-fw"></i>
                          </Link>
                        </InputGroupAddon>
                      </InputGroup>
                    </form>
                  </div>
                </div>
              </Alert>
              <PanelBody>
                {!loading && data.AdminCouponList.count > 0 ? (
                  <>
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped m-b-0">
                        <thead>
                          <tr>
                            <th>상태</th>
                            <th>분류</th>
                            <th>제목</th>
                            <th>기간</th>
                            <th>금액</th>
                            <th>가맹점</th>
                            <th>등록일시</th>
                            <th>기능</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.AdminCouponList.coupons.map((item) => {
                            return (
                              <tr key={item.id}>
                                <td>{commonStatusName(item.commonStatus)}</td>
                                <td>{item.couponCategory.name}</td>
                                <td>{item.title}</td>
                                <td>
                                  <ReactMoment format="YYYY-MM-DD">
                                    {item.startDate}
                                  </ReactMoment>{" "}
                                  ~{" "}
                                  <ReactMoment format="YYYY-MM-DD">
                                    {item.endDate}
                                  </ReactMoment>
                                </td>
                                <td>
                                  <NumberFormat
                                    value={item.price}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                  />
                                  드림
                                </td>
                                <td>{item.store.name}</td>
                                <td>
                                  <ReactMoment format="YYYY-MM-DD HH:mm:ss">
                                    {item.createdAt}
                                  </ReactMoment>
                                </td>
                                <td>
                                  <Link
                                    className={`btn btn-white btn-xs text-green m-r-5`}
                                    to={`/couponConfigs/${config.AdminCouponConfig.id}/coupons/${item.id}${location.search}`}
                                  >
                                    쿠폰정보
                                  </Link>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="row p-t-15">
                      <div className="col-md-12">
                        <Pagination
                          totalRecord={data.AdminCouponList.count}
                          blockSize={blockSize}
                          pageSize={first}
                          currentPage={page}
                          baseUrl={baseUrl}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <p className="text-center">등록된 데이터가 없습니다.</p>
                )}
              </PanelBody>
            </Panel>
          </div>
        </div>
      </div>
      <Link
        to={`/couponConfigs/${config.AdminCouponConfig.id}/coupons/write${location.search}`}
        className="btn btn-icon btn-circle btn-lg btn-primary btn-scroll-to-top"
      >
        <i className="fas fa-pencil-alt"></i>
      </Link>
    </>
  );
};

export default List;
